import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Typography", "numOfLines", "truncated", "onChangeOverflow", "timeout", "children"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/core/components/MultilineTruncateParagraph/index.js",
  _this = this;
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { noop } from '../../../helpers';
import { useWindowSize } from '../../hooks/windowSize';
var MultilineTruncateParagraph = function MultilineTruncateParagraph(_ref) {
  var Typography = _ref.Typography,
    numOfLines = _ref.numOfLines,
    truncated = _ref.truncated,
    onChangeOverflow = _ref.onChangeOverflow,
    timeout = _ref.timeout,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverFlow = _useState2[0],
    setOverflow = _useState2[1];
  var textRef = useRef(null);
  var windowSize = useWindowSize();
  var processTruncateText = useCallback(function (node) {
    var words = children.split(' ');
    node.textContent = words[0];
    var maxHeight = node.clientHeight * numOfLines; // get the the paragraph max height when truncated

    var truncatedStr = '';
    var overflow = words.some(function (word) {
      var prevStr = truncatedStr;
      truncatedStr = truncatedStr ? "".concat(truncatedStr, " ").concat(word) : word; // concat the paragraph word by word

      node.textContent = truncatedStr;
      if (node.clientHeight > maxHeight) {
        // when the truncated paragraph exceeds the max height
        node.textContent = "".concat(prevStr, "...");
        if (node.clientHeight > maxHeight) {
          // replace the last 4 letters by '...' to make sure it's not going to the next line
          node.textContent = "".concat(prevStr.substring(0, prevStr.length - 4), "...");
        }
        return true;
      }
      return false;
    });
    setOverflow(function (prevState) {
      return prevState ? prevState : overflow;
    });
  }, [children, numOfLines]);
  useEffect(function () {
    onChangeOverflow(isOverFlow);
  }, [isOverFlow]);
  useEffect(function () {
    var transitionTimeout;
    if (textRef.current && truncated) {
      transitionTimeout = setTimeout(function () {
        processTruncateText(textRef.current);
      }, timeout);
    }
    return function () {
      return clearTimeout(transitionTimeout);
    };
  }, [truncated, windowSize, numOfLines]);
  return /*#__PURE__*/React.createElement(Typography, _extends({
    tag: "span"
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 5
    }
  }), truncated && /*#__PURE__*/React.createElement("div", {
    ref: textRef,
    "data-testid": "truncatedTextId",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 9
    }
  }, children), !truncated && /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 22
    }
  }, children));
};
MultilineTruncateParagraph.defaultProps = {
  onChangeOverflow: noop,
  truncated: true,
  timeout: 0,
  children: ''
};
export default MultilineTruncateParagraph;